import React from 'react'
import './Dashboard.css'

interface DashboardProps {
  onNavigate?: (tab: string) => void
}

const Dashboard: React.FC<DashboardProps> = ({ onNavigate }) => {
  const stats = [
    { label: '相爱天数', value: '1234', icon: '💕', color: '#ff69b4' },
    { label: '美好回忆', value: '156', icon: '📸', color: '#ff6b6b' },
    { label: '完成目标', value: '23', icon: '🎯', color: '#4ecdc4' },
    { label: '情感记录', value: '89', icon: '💖', color: '#45b7d1' }
  ]

  const recentMemories = [
    { id: 1, title: '第一次约会', date: '2024-01-15', image: '🌹', emotion: '开心' },
    { id: 2, title: '一起看电影', date: '2024-01-20', image: '🎬', emotion: '浪漫' },
    { id: 3, title: '海边散步', date: '2024-01-25', image: '🌊', emotion: '温馨' }
  ]

  const upcomingGoals = [
    { id: 1, title: '一起旅行', progress: 75, dueDate: '2024-03-01' },
    { id: 2, title: '学习新技能', progress: 45, dueDate: '2024-04-15' },
    { id: 3, title: '健身计划', progress: 60, dueDate: '2024-02-28' }
  ]

  return (
    <div className="dashboard">
      <div className="welcome-section">
        <h2 className="welcome-title">欢迎回来！💕</h2>
        <p className="welcome-subtitle">记录每一个美好瞬间，让爱情更加甜蜜</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div 
            key={index} 
            className="stat-card clickable" 
            style={{ borderColor: stat.color }}
            onClick={() => {
              if (stat.label === '美好回忆') onNavigate?.('memories')
              else if (stat.label === '完成目标') onNavigate?.('goals')
              else if (stat.label === '情感记录') onNavigate?.('emotions')
              else if (stat.label === '相爱天数') onNavigate?.('statistics')
            }}
          >
            <div className="stat-icon" style={{ color: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <div className="stat-value" style={{ color: stat.color }}>
                {stat.value}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-content">
        <div className="section">
          <h3 className="section-title">最近回忆 📸</h3>
          <div className="memories-list">
            {recentMemories.map(memory => (
              <div key={memory.id} className="memory-item">
                <div className="memory-image">{memory.image}</div>
                <div className="memory-info">
                  <h4 className="memory-title">{memory.title}</h4>
                  <p className="memory-date">{memory.date}</p>
                  <span className="memory-emotion">{memory.emotion}</span>
                </div>
              </div>
            ))}
          </div>
          <button className="btn btn-secondary view-all-btn" onClick={() => onNavigate?.('memories')}>
            查看全部回忆 →
          </button>
        </div>

        <div className="section">
          <h3 className="section-title">进行中的目标 🎯</h3>
          <div className="goals-list">
            {upcomingGoals.map(goal => (
              <div key={goal.id} className="goal-item">
                <div className="goal-info">
                  <h4 className="goal-title">{goal.title}</h4>
                  <p className="goal-date">截止日期: {goal.dueDate}</p>
                </div>
                <div className="goal-progress">
                  <div className="progress-bar">
                    <div 
                      className="progress-fill" 
                      style={{ width: `${goal.progress}%` }}
                    ></div>
                  </div>
                  <span className="progress-text">{goal.progress}%</span>
                </div>
              </div>
            ))}
          </div>
          <button className="btn btn-secondary view-all-btn" onClick={() => onNavigate?.('goals')}>
            查看全部目标 →
          </button>
        </div>
      </div>

      <div className="quick-actions">
        <h3 className="section-title">快速操作</h3>
        <div className="actions-grid">
          <button className="action-btn" onClick={() => onNavigate?.('memories')}>
            <span className="action-icon">📸</span>
            <span className="action-text">添加回忆</span>
          </button>
          <button className="action-btn" onClick={() => onNavigate?.('goals')}>
            <span className="action-icon">🎯</span>
            <span className="action-text">设定目标</span>
          </button>
          <button className="action-btn" onClick={() => onNavigate?.('emotions')}>
            <span className="action-icon">💕</span>
            <span className="action-text">记录心情</span>
          </button>
          <button className="action-btn" onClick={() => onNavigate?.('statistics')}>
            <span className="action-icon">📊</span>
            <span className="action-text">查看统计</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Dashboard